<template>
  <div>
    <v-layout mt-2 wrap justify-center align-center>
      <v-flex xs6 sm3 md3>
        <v-card>
          <v-toolbar flat color="primary">
            <v-spacer></v-spacer>
            <h3 class="title white--text">
              Billing Period:
              <br />
              {{formatDate(startdate)}}-{{formatDate(enddate)}}
            </h3>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap text-xs-left>
              <v-flex xs6>
                <h3 class="grey--text">Once-off sales</h3>
              </v-flex>
              <v-flex xs6>
                <span
                  class="grey--text"
                >{{billingData.reduce((a, b) => +a + +b.onceOff, 0)|currency}}</span>
              </v-flex>
              <v-flex xs6>
                <h3 class="grey--text">Recurring sales</h3>
              </v-flex>
              <v-flex xs6>
                <span
                  class="grey--text"
                >{{billingData.reduce((a, b) => +a + +b.prorata, 0)|currency}}</span>
              </v-flex>
              <v-flex xs12>
                <v-divider color="grey"></v-divider>
              </v-flex>
              <v-flex xs6 mt-2>
                <h3 class="grey--text font-weight-bold">Total</h3>
              </v-flex>
              <v-flex xs6 mt-2>
                <span
                  class="grey--text font-weight-bold"
                >{{billingData.reduce((a, b) => +a + +b.prorata, 0)+billingData.reduce((a, b) => +a + +b.onceOff, 0)|currency}}</span>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6 sm3 md3>
        <doughnutchart
          v-if="loaded"
          :chartdata="ispPackagesChartData"
          :options="ispPackagesChartOptions"
        ></doughnutchart>
      </v-flex>
      <v-flex xs6 sm3 md3>
        <barchart v-if="loaded" :chartdata="ispChartData" :options="ispChartOptions"></barchart>
      </v-flex>
       <v-flex xs6 sm3 md3>
      
          <v-container  text-lg-center pt-5 text-xs-left>
              <v-layout align-center justify-left text-xs-left>
                  <v-card flat color="white" text-xs-left>
                  <v-flex xs12 sm12 md12>
                      <v-layout my-5 wrap >
                          <v-flex xs2 my-2><v-icon>home</v-icon></v-flex>
                          <v-flex xs8 my-2><h3>Units Passed: </h3></v-flex>
                          <v-flex xs2 my-2><v-chip class="white--text" color="purple"> {{unitspassed.count}}</v-chip></v-flex>

                      <!-- </v-layout>

                       <v-layout my-5 > -->
                          <v-flex xs2 my-2><v-icon>share</v-icon></v-flex>
                          <v-flex xs8 my-2><h3 >Units Connected: </h3></v-flex>
                          <v-flex xs2 my-2><v-chip class="white--text" color="orange"> {{unitsconnected.count}}</v-chip></v-flex>

                      <!-- </v-layout>

                       <v-layout my-5 > -->
                          <v-flex xs2 my-2><v-icon>devices_other</v-icon></v-flex>
                          <v-flex xs8 my-2><h3>Service Accounts: </h3></v-flex>
                          <v-flex xs2 my-2><v-chip class="white--text" color="light-green"> {{activeaccounts.count}}</v-chip></v-flex>

                      <!-- </v-layout>

                       <v-layout my-5 > -->
                          <v-flex xs2 my-2><v-icon>wifi</v-icon></v-flex>
                          <v-flex xs8 my-2><h3 >Provisioned Connections:</h3></v-flex>
                          <v-flex xs2 my-2><v-chip class="white--text" color="blue"> {{provisionedconnectionscount.count}}</v-chip></v-flex>

                      </v-layout>
          </v-flex>
          </v-card>
          </v-layout>
          </v-container>
          </v-flex>
    </v-layout>
    <v-layout justify-center>
       <v-flex xs12 sm12 md12 v-if="networkdata.length>6">
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex>
      <v-flex xs12 sm6 md6 v-else-if="networkdata.length>3">
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex>
      <v-flex xs12 sm4 md4 v-else>
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import BarChart from "./BarChart.vue";
import PieChart from "./PieChart.vue";
import LineChart from "./LineChart.vue";
import dateformat from "dateformat";
import DoughnutChart from "./DoughnutChart.vue";

export default {
  components: {
    barchart: BarChart,
    piechart: PieChart,
    linechart: LineChart,
    doughnutchart: DoughnutChart
  },
  props: [
    "billingData",
    "networkdata",
    "networkspeeds",
    "packagedata",
    "ispdata",
    "startdate",
    "enddate",
    "unitspassed",
    "unitsconnected",
    "provisionedconnectionscount",
    "activeaccounts"
  ],
  data() {
    return {
      loaded: false,
      ispPackagesChartData: {},
      ispPackagesChartOptions: {},
      networkChartData: {},
      networkChartOptions: {},
      stackedData: {},
      stackedDataOptions: {},
      ispChartData: {},
      ispChartDataOptions: {}
    };
  },
  created() {
    this.loaded = false;
  },
  async mounted() {
    this.loadCharts();
  },
  methods: {
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    navigateServiceAccounts() {
      this.$router.push({ path: "/serviceAccounts" });
    },
    navigateApplications() {
      this.$router.push({ path: "/applications" });
    },
    async loadCharts() {
      //   Packages Chart
      let colors = this.getRandomColors(this.packagedata.length);
      (this.ispPackagesChartData = {
        labels: this.packagedata.map(x => x.speedProfile.downloadMbps + "Mbps"),
        datasets: [
          {
            label: "Speed",
            data: this.packagedata.map(x => x.count),
            backgroundColor: this.packagedata.map(x => this.pSBC(0.35, x.colour)),
            borderColor: this.packagedata.map(x => x.colour),
            borderWidth: 1
          }
        ]
      }
      ),
        (this.ispPackagesChartOptions = {
          title: {
            display: true,
            text: "Packages Sales by Speed"
          },
        //   tooltip: {
        //     enabled: true
        //   },
          tooltips: {
      callbacks: {
        title: function(tooltipItem, data) {
          return data['labels'][tooltipItem[0]['index']];
        },
        label: function(tooltipItem, data) {
          return 'R'+Number(data['datasets'][0]['data'][tooltipItem['index']]).toFixed(0).replace(/./g, function(c, i, a) {
                      return i > 0 && c !== "." && (a.length - i) % 3 === 0
                        ? "," + c
                        : c;
                    });
        },
        afterLabel: function(tooltipItem, data) {
          var dataset = (data['datasets'][0]);
          try {
            var percent = Math.round((dataset['data'][tooltipItem['index']] / dataset["_meta"][0]['total']) * 100)
          return '(' + percent + '%)';
          } catch(e){
            return 
          }
          
        }
      }},
        });

      // Network Chart
      let networkColors = this.getRandomColors(this.networkdata.length);
      (this.networkChartData = {
        labels: this.networkdata.map(x => x.locationNetwork.name),
        datasets: [
          {
            label: "Sold",
            data: this.networkdata.map(x => x.count),
            backgroundColor: networkColors.background,
            borderColor: networkColors.border,
            borderWidth: 1
          }
        ]
      }),
        (this.networkChartOptions = {
          title: {
            display: true,
            text: "Packages Sold by Network"
          },
          tooltip: {
            enabled: true
          }
        }),
        (this.ispChartData = {
          labels: this.ispdata.map(x => x.customerOrganisation.name),
          datasets: [
            {
              label: "Total",
              data: this.ispdata.map(x => x.count),
              backgroundColor: this.pSBC(0.35, this.$vuetify.theme.primary),
              borderColor: this.$vuetify.theme.primary,
              borderWidth: 1
            }
          ]
        }),
        (this.ispChartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: "Sales by ISP"
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return (
                  "R" +
                  Number(tooltipItem.yLabel)
                    .toFixed(0)
                    .replace(/./g, function(c, i, a) {
                      return i > 0 && c !== "." && (a.length - i) % 3 === 0
                        ? "," + c
                        : c;
                    })
                );
              }
            }
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  callback: function(value) {
                    if (parseInt(value) >= 1000) {
                      return (
                        "R" +
                        value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      );
                    } else {
                      return "R" + value;
                    }
                  }
                }
              }
            ]
          }
        }),
        await this.networkspeeds.map(z => {
          // let index = this.networkspeeds.indexOf(z);
          z.backgroundColor = this.pSBC(0.35, z.colour)
          z.borderColor = z.colour;
        });
      (this.stackedData = {
        labels: this.networkdata.map(x => x.locationNetwork.name),
        datasets: this.networkspeeds
      }),
        (this.stackedDataOptions = {
          title: {
            display: true,
            text: "Sales by Network"
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.8,
                barPercentage: 1
              }
            ],
            yAxes: [
              {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  callback: function(value) {
                    if (parseInt(value) >= 1000) {
                      return (
                        "R" +
                        value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      );
                    } else {
                      return "R" + value;
                    }
                  }
                }
              }
            ]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return (
                  "R" +
                  Number(tooltipItem.yLabel)
                    .toFixed(0)
                    .replace(/./g, function(c, i, a) {
                      return i > 0 && c !== "." && (a.length - i) % 3 === 0
                        ? "," + c
                        : c;
                    })
                );
              }
            }
          }
        });

      this.loaded = true;
    },
    getRandomColors(number) {
      var letters = "0123456789ABCDEF";
      var color = "#";
      let array = { background: [], border: [] };
      for (let x = 0; x < number; x++) {
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        array.border.push(color);
        array.background.push(this.pSBC(0.35, color));
        color = "#";
      }
      return array;
    },
    pSBC(p, c0, c1, l) {
      let r,
        g,
        b,
        P,
        f,
        t,
        h,
        i = parseInt,
        m = Math.round,
        a = typeof c1 == "string";
      if (
        typeof p != "number" ||
        p < -1 ||
        p > 1 ||
        typeof c0 != "string" ||
        (c0[0] != "r" && c0[0] != "#") ||
        (c1 && !a)
      )
        return null;
      if (!this.pSBCr)
        this.pSBCr = d => {
          let n = d.length,
            x = {};
          if (n > 9) {
            ([r, g, b, a] = d = d.split(",")), (n = d.length);
            if (n < 3 || n > 4) return null;
            (x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))),
              (x.g = i(g)),
              (x.b = i(b)),
              (x.a = a ? parseFloat(a) : -1);
          } else {
            if (n == 8 || n == 6 || n < 4) return null;
            if (n < 6)
              d =
                "#" +
                d[1] +
                d[1] +
                d[2] +
                d[2] +
                d[3] +
                d[3] +
                (n > 4 ? d[4] + d[4] : "");
            d = i(d.slice(1), 16);
            if (n == 9 || n == 5)
              (x.r = (d >> 24) & 255),
                (x.g = (d >> 16) & 255),
                (x.b = (d >> 8) & 255),
                (x.a = m((d & 255) / 0.255) / 1000);
            else
              (x.r = d >> 16),
                (x.g = (d >> 8) & 255),
                (x.b = d & 255),
                (x.a = -1);
          }
          return x;
        };
      (h = c0.length > 9),
        (h = a ? (c1.length > 9 ? true : c1 == "c" ? !h : false) : h),
        (f = this.pSBCr(c0)),
        (P = p < 0),
        (t =
          c1 && c1 != "c"
            ? this.pSBCr(c1)
            : P
            ? { r: 0, g: 0, b: 0, a: -1 }
            : { r: 255, g: 255, b: 255, a: -1 }),
        (p = P ? p * -1 : p),
        (P = 1 - p);
      if (!f || !t) return null;
      if (l)
        (r = m(P * f.r + p * t.r)),
          (g = m(P * f.g + p * t.g)),
          (b = m(P * f.b + p * t.b));
      else
        (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
          (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
          (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
      (a = f.a),
        (t = t.a),
        (f = a >= 0 || t >= 0),
        (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
      if (h)
        return (
          "rgb" +
          (f ? "a(" : "(") +
          r +
          "," +
          g +
          "," +
          b +
          (f ? "," + m(a * 1000) / 1000 : "") +
          ")"
        );
      else
        return (
          "#" +
          (
            4294967296 +
            r * 16777216 +
            g * 65536 +
            b * 256 +
            (f ? m(a * 255) : 0)
          )
            .toString(16)
            .slice(1, f ? undefined : -2)
        );
    }
  }
};
</script>